import React from 'react';
import './Services.css';

const services = [
  {
    icon: '🏗️',
    title: 'Residential Construction',
    desc: 'Custom homes, apartments, and housing complexes built with quality materials and modern designs.',
  },
  {
    icon: '🏢',
    title: 'Commercial Construction',
    desc: 'Office buildings, retail spaces, and commercial complexes designed for functionality and aesthetics.',
  },
  {
    icon: '🔧',
    title: 'Renovation & Remodeling',
    desc: 'Transform existing spaces with our expert renovation services for both residential and commercial properties.',
  },
  {
    icon: '🌉',
    title: 'Infrastructure Development',
    desc: 'Roads, bridges, and public infrastructure projects delivered with precision and reliability.',
  },
  {
    icon: '📋',
    title: 'Project Consulting',
    desc: 'Expert guidance on project planning, feasibility studies, and construction management.',
  },
  {
    icon: '🏠',
    title: 'Interior Design',
    desc: 'End-to-end interior design solutions that complement our construction services.',
  },
];

const Services = () => {
  return (
    <section className="services section" id="services">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
